import { Location } from '@angular/common';
import { Component, HostListener, inject, OnInit, signal, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { PhysicalInventoryReportComponent } from '../../physical-inventory-report/physical-inventory-report.component';
import { RegisterPhysicalInventoryComponent } from '../register-physical-inventory/register-physical-inventory.component';

@Component({
  selector: 'app-physical-inventory',
  templateUrl: './physical-inventory.component.html',
  styleUrls: ['./physical-inventory.component.scss'],
  standalone: false
})
export class PhysicalInventoryComponent implements OnInit {

  private readonly headerService = inject(HeaderService);
  private readonly location = inject(Location);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);

  @ViewChild(RegisterPhysicalInventoryComponent) registerPhysicalInventoryComponent?: RegisterPhysicalInventoryComponent;
  @ViewChild(PhysicalInventoryReportComponent) physicalInventoryReportComponent?: PhysicalInventoryReportComponent;

  readonly tabs = ['Captura de Datos', 'Informes'];
  readonly activeTab = signal<string>(this.tabs[0]);

  isOpened: string | undefined = undefined;
  nameWindow: string = 'Inventario Físico';
  projectName = ProjectName.projectName;
  url: string = "physical-inventory";

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.validateOpenWindow();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  createNewRegister() {
    this.activeTab.set(this.tabs[0]);
    this.registerPhysicalInventoryComponent?.createNewRegister();
  }

  getPhysicalInventoryIdForReports(): number {
    return this.registerPhysicalInventoryComponent?.physicalInventoryId ?? 0;
  }

  private getRegisterPhysicalInventoryUrl(): string {
    const physicalInventoryId = this.registerPhysicalInventoryComponent?.physicalInventoryId ?? 0;

    if (physicalInventoryId && physicalInventoryId !== 0) {
      return `/physical-inventory/register/${physicalInventoryId}`;
    }

    return '/physical-inventory/register';
  }

  selectTab(tab: string) {
    this.activeTab.set(tab);
    if (tab === this.tabs[0]) {
      this.location.replaceState(this.getRegisterPhysicalInventoryUrl());
    } else {
      this.location.replaceState(`/physical-inventory`);
      this.physicalInventoryReportComponent?.onReportsTabSelected(this.getPhysicalInventoryIdForReports());
    }
  }

  async validateOpenWindow() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
  }

}
